<template>
  <div
    id="app"
    class="relative"
    data-test="main-screen"
  >
    <LoadingSpinner v-if="loading" />

    <MaintenanceScreen
      v-else-if="maintenanceEnabled"
      class="h-full flex items-center justify-center"
    />

    <RouterView v-else />
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue'
import { useActions } from 'vuex-composition-helpers/dist'

import { MaintenanceScreen } from '@/components/screens/MaintenanceScreen'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

import { useFlagEnabled } from '@/composables/useFlagEnabled'
import { onFlagStateChange } from '@/lib/launchDarkly'

const { setFlags } = useActions({
  setFlags: 'featureFlags/SET_FLAGS'
})

const [loading, maintenanceEnabled] = useFlagEnabled('planned-maintenance')

onBeforeMount(() => {
  onFlagStateChange((allFlags) => {
    setFlags(allFlags)
  })
})
</script>

<style lang="sass">
  @import '@/styles/manifest.sass'
</style>
